import { Box, Grid, HStack } from '@chakra-ui/react';
import { NextPage } from 'next';
import React from 'react';

import MainLayout from '@app/components/MainLayout';
import { PageTitle } from '@app/components/PageTitle';
import { AllocationWidget } from '@app/screens/rewards/components/AllocationWidget';
import { PendingRewardsWidget } from '@app/screens/rewards/components/PendingRewardsWidget';
import { EpochWidget } from '@app/screens/rewards/components/EpochWidget';
import { FeatureFlagWrapper } from '@app/components/FeatureFlagWrapper';
import { useDividentsStats } from '@app/hooks/ryo/useDividentsStats';
import { formatNumber } from '@app/helpers/format';
import { SimpleValueWidget } from '@app/components/SimpleValueWidget';
import { useConfig } from '@app/config';
import Metadata from '@app/components/Metadata';
import AnimatedLayout from '@app/layouts/AnimatedLayout/AnimatedLayout';

export const RewardsPage: NextPage = () => {
  const { totalAllocation, deallocationFee } = useDividentsStats();
  const config = useConfig();

  return (
    <AnimatedLayout>
      <Metadata title={'Rewards | Kim'} />
      <FeatureFlagWrapper show={!!config?.FLAGS.showRyoPages}>
        <Box mt={8} px={[0, 7]}>
          <PageTitle
            title="Rewards"
            subtitle="Allocate KIM here to earn a share of protocol earnings in the form of real yield and receive weekly protocol earnings with KIM"
          />
          <HStack
            mt={8}
            border="1px solid #1B1B1B"
            rounded="2xl"
            px={3}
            py={4}
            gap={4}
            flexWrap="wrap"
            width={'fit-content'}
            justify={'flex-start'}
          >
            <Box border="1px solid rgba(255, 255, 255, 0.06)" rounded="2xl">
              <SimpleValueWidget
                hasGrayBg
                noBorder
                label="TOTAL ALLOCATIONS"
                value={formatNumber(+totalAllocation ?? 0, 2)}
              />
            </Box>
            <Box border="1px solid rgba(255, 255, 255, 0.06)" rounded="2xl">
              <SimpleValueWidget
                hasGrayBg
                noBorder
                label={`DEALLOCATION FEE`}
                value={deallocationFee + '%'}
              />
            </Box>
          </HStack>
          <Grid
            gridTemplateColumns={['1fr', '1fr', '1fr', '1.5fr 2fr']}
            mt="40px"
            gridColumnGap="20px"
          >
            <Box>
              <AllocationWidget />
            </Box>

            <PendingRewardsWidget />
          </Grid>

          <Box mt="24px">
            <EpochWidget />
          </Box>
        </Box>
      </FeatureFlagWrapper>
    </AnimatedLayout>
  );
};

export default RewardsPage;
